import { useState, type SyntheticEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import Input from '@components/ui/Input.js';
import Button from '@components/ui/Button.js';
import { useLoginMutation } from '@features/auth/hooks/useAuth.js';

export default function LoginPage() {
  const history = useHistory();
  const loginMutation = useLoginMutation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  function handleSubmit(e: SyntheticEvent) {
    e.preventDefault();
    void loginMutation.mutateAsync({ email, password }).then(() => {
      history.push('/policies');
    });
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-body-bg p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-sm"
      >
        <div className="rounded-2xl border border-line bg-surface p-8 shadow-lg">
          <div className="mb-8 text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-[18px] bg-slate text-white shadow-[0_8px_24px_rgba(15,118,110,0.30)]">
              <ShieldCheck size={28} strokeWidth={2} />
            </div>
            <h1 className="text-xl font-black tracking-tight text-ink">InsurTrack Pro</h1>
            <p className="mt-1 text-sm text-ink-soft">Sign in to your account</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Email"
              type="email"
              placeholder="agent@insurtrack.com"
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(e.target.value);
              }}
              required
            />

            <Input
              label="Password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPassword(e.target.value);
              }}
              required
            />

            {loginMutation.isError && loginMutation.error instanceof Error && (
              <p className="text-xs font-medium text-red-fg">{loginMutation.error.message}</p>
            )}

            <Button type="submit" className="w-full" disabled={loginMutation.isPending}>
              {loginMutation.isPending ? 'Signing in...' : 'Sign in'}
            </Button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
